/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';

import { Card } from '@kaiizen/kai-shiki/react';
import {
  EMPTY_CANVAS_CONTENT_STYLE,
  EMPTY_CANVAS_DESCRIPTION_STYLE,
  EMPTY_CANVAS_DETAIL_STYLE,
  EMPTY_CANVAS_ICON_BOX_STYLE,
  EMPTY_CANVAS_STATE_STYLE,
  EMPTY_CANVAS_TITLE_STYLE,
  EMPTY_PANEL_CONTENT_STYLE,
  EMPTY_PANEL_DESCRIPTION_STYLE,
  EMPTY_PANEL_STATE_STYLE,
  EMPTY_PANEL_TITLE_STYLE,
} from './FocusedArtifactPanelStyleLib';

/** Shared empty-state layouts for artifact history and audience-doc copies. */
export const ArtifactEmptyState = ({
  variant,
  icon,
  title,
  description,
  detail,
}: {
  variant: 'canvas' | 'panel';
  icon?: ReactNode;
  title: string;
  description: string;
  detail?: string;
}) => (
  variant === 'canvas'
    ? (
      <div css={EMPTY_CANVAS_STATE_STYLE}>
        <div css={EMPTY_CANVAS_CONTENT_STYLE}>
          {icon ? <div css={EMPTY_CANVAS_ICON_BOX_STYLE}>{icon}</div> : null}
          <div css={EMPTY_CANVAS_TITLE_STYLE}>{title}</div>
          <div css={EMPTY_CANVAS_DESCRIPTION_STYLE}>{description}</div>
          {detail ? <div css={EMPTY_CANVAS_DETAIL_STYLE}>{detail}</div> : null}
        </div>
      </div>
    )
    : (
      <Card variant='outlined' css={EMPTY_PANEL_STATE_STYLE}>
        <div css={EMPTY_PANEL_CONTENT_STYLE}>
          <div css={EMPTY_PANEL_TITLE_STYLE}>{title}</div>
          <div css={EMPTY_PANEL_DESCRIPTION_STYLE}>{description}</div>
        </div>
      </Card>
    )
);
